import styled from 'styled-components';
import { getHexOpacity } from "../../../../../utils/pipes";

export const PatientProfile = styled.div`
  height: 100%;
`